import { useIntl } from "react-intl";
import { Button } from "@/components/design/Button";
import type { ButtonSize } from "@/components/design/button-classes";

// Der Stern auf den Detailseiten. Bewusst dumm (markiert + onToggle statt des
// ganzen Hooks): so laesst er sich ohne Netzwerk rendern und testen, und die
// Detailseite bleibt die Stelle, die den Zustand haelt.
//
// Zustand ueber die Glyphe und nicht ueber Farbe (★ gefuellt / ☆ offen), wie
// StarRating es fuer die SHARE-Bewertung schon macht: Farbe ist laut
// UI_CONVENTIONS Aktionen vorbehalten, nicht Datenzustaenden. aria-pressed
// macht denselben Zustand fuer Screenreader lesbar, weil die Glyphe dort nur
// als "schwarzer Stern" ankommt.
export function TobisFavoriteButton({
  marked,
  onToggle,
  size = "md",
}: {
  marked: boolean;
  onToggle: () => void;
  size?: Extract<ButtonSize, "sm" | "md">;
}) {
  const intl = useIntl();
  const label = marked
    ? intl.formatMessage({ id: "tobis.favorite.remove", defaultMessage: "Remove from favourites" })
    : intl.formatMessage({ id: "tobis.favorite.add", defaultMessage: "Add to favourites" });

  return (
    <Button
      variant="icon"
      size={size}
      onClick={onToggle}
      aria-pressed={marked}
      aria-label={label}
      title={label}
    >
      <span aria-hidden="true" className={marked ? "text-ink" : "text-ink/45"}>
        {marked ? "★" : "☆"}
      </span>
    </Button>
  );
}
